import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as editorActions from '../../editor/editor.action';

import BtnEditarResponsavel from './BtnEditarResponsavel';
import BtnEditarRevisor from './BtnEditarRevisor';
import {
  tipoMedicoEnum,
  etapasEnum,
  statusEtapasEnum,
} from '@common/util/defaultValues';
import { atributosMedicoDetalhes } from '../detalhes.utils';
import { getUsuarioLocalStorage } from '../../../../localStorage.util';

function Medico({ tipoMedico }) {
  const dispatch = useDispatch();
  const detalhes = useSelector((state) => state.commonReducer.detalhes);
  const etapa = useSelector((state) => state.commonReducer.etapa);
  const medicos = useSelector((state) => state.commonReducer.medicos);

  const [etapaSelecionada, setEtapaSelecionada] = useState('');
  const [medicoNome, setMedicoNome] = useState('');
  const [medicoSelecionado, setMedicoSelecionado] = useState();
  const [titulo, setTitulo] = useState('');

  useEffect(() => {
    setTitulo(tipoMedico === tipoMedicoEnum.MEDICO ? 'Responsável' : 'Revisor');
  }, []);

  useEffect(() => {
    setEtapaSelecionada(etapa.etapa);
  }, [etapa]);

  useEffect(() => {
    let medicoId;
    if (tipoMedico === tipoMedicoEnum.MEDICO) {
      medicoId =
        detalhes[
          `med${
            etapa.etapa[0].toUpperCase() +
            etapa.etapa.slice(1, etapa.etapa.lenght).toLowerCase()
          }`
        ];
        if (medicoId && medicoSelecionado && medicoId !== medicoSelecionado.value) {
          setMedico(medicoId);
        }
    } else {
      medicoId =
        detalhes[
          `revisor${
            etapa.etapa[0].toUpperCase() +
            etapa.etapa.slice(1, etapa.etapa.lenght).toLowerCase()
          }`
        ];
        if (medicoId && medicoSelecionado && medicoId !== medicoSelecionado.value) {
          setMedico(medicoId);
        }
    }
  }, [detalhes]);

  useEffect(() => {
    const newEtapa = capitalize(etapaSelecionada);

    tipoMedico === tipoMedicoEnum.REVISOR
      ? setMedico(detalhes[`revisor${newEtapa}`])
      : setMedico(detalhes[`med${newEtapa}`]);
  }, [etapaSelecionada, medicos, tipoMedico]);

  const capitalize = (string) => {
    return `${string.charAt(0).toUpperCase()}${string.toLowerCase().slice(1)}`;
  };

  const setMedico = (id) => {
    const medico = medicos.find((m) => m.value === Number(id || 0));
    const nome = medico ? medico.label : '';
    medico ? setMedicoSelecionado(medico) : setMedicoSelecionado({});
    setMedicoNome(nome);

    if (id) {
      tipoMedico === tipoMedicoEnum.MEDICO
        ? dispatch(editorActions.ChangeMedExecutante(id))
        : dispatch(editorActions.ChangeMedRevisor(id));
    } else {
      setMedicoDefault();
    }
  };

  const setMedicoDefault = () => {
    if (!etapaSelecionada || etapaSelecionada === etapasEnum.MATERIAL) return;

    const statusEtapa = getStatusEtapa();
    const usuarioLogado = getUsuarioLocalStorage();
    const newEtapa = capitalize(etapaSelecionada);

    let medicoId = null;
    let detalhesUpdate = { ...detalhes };

    if (usuarioLogado.medicoId) {
      // é médico
      medicoId = usuarioLogado.medicoId;
      if (tipoMedico === tipoMedicoEnum.MEDICO) {
        detalhesUpdate[`med${newEtapa}`] = medicoId;
        dispatch(editorActions.ChangeMedExecutante(medicoId));
      } else {
        detalhesUpdate[`revisor${newEtapa}`] = medicoId;
        dispatch(editorActions.ChangeMedRevisor(medicoId));
      }
      dispatch(commonActions.atualizarDetalhes(detalhesUpdate));
    }
    if (
      !medicoId && // é digitador
      etapaSelecionada !== etapasEnum.MACRO &&
      etapaSelecionada !== etapasEnum.MICRO &&
      (statusEtapa === statusEtapasEnum.NAO_REALIZADO ||
        statusEtapa === statusEtapasEnum.PENDENTE)
    ) {
      /* Se o usuario logado for digitador a rotina abaixo usará o medico selecionado na micro para as proximas etapas ANATOWEB-2966*/
      if (tipoMedico === tipoMedicoEnum.MEDICO) {
        detalhesUpdate[`med${newEtapa}`] = detalhes.medMicro;
        dispatch(editorActions.ChangeMedExecutante(detalhes.medMicro));
      } else {
        detalhesUpdate[`revisor${newEtapa}`] = detalhes.revisorMicro;
        dispatch(editorActions.ChangeMedRevisor(detalhes.revisorMicro));
      }
      dispatch(commonActions.atualizarDetalhes(detalhesUpdate));
    }
  };

  const getStatusEtapa = () => {
    const atributos = atributosMedicoDetalhes.find((a) => a.id === etapa.tab);
    if (atributos === null || atributos === undefined) return undefined;

    if (detalhes === null || detalhes === undefined) return undefined;

    const checkEtapa = detalhes.etapas.find(
      (el) => el.etapa === atributos.etapa
    );
    return checkEtapa !== null && checkEtapa !== undefined
      ? checkEtapa.status
      : undefined;
  };

  return (
    <span style={{ display: 'flex' }}>
      <strong>{`${titulo} (${etapaSelecionada}):`} &nbsp;</strong>
      {medicoNome}
      {tipoMedico === tipoMedicoEnum.MEDICO && (
        <BtnEditarResponsavel
          className="btn-atualizar"
          medicos={medicos}
          medicoSelecionado={medicoSelecionado}
          etapa={etapa}
          setMedicoSelecionado={setMedicoSelecionado}
          getStatusEtapa={getStatusEtapa}
          />
          )}
      {tipoMedico === tipoMedicoEnum.REVISOR && (
        <BtnEditarRevisor
          className="btn-atualizar"
          medicos={medicos}
          medicoSelecionado={medicoSelecionado}
          etapa={etapa}
          setMedicoSelecionado={setMedicoSelecionado}
          getStatusEtapa={getStatusEtapa}
        />
      )}
    </span>
  );
}

export default Medico;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/Medico/index.js